module.exports = __webpack_public_path__ + "static/media/Desktop 20-3-2566 22-35-37.3de1faf2.gif";